const Pricing = () => {
  return (
    <div>
      <h2>Pricing Page</h2>
      <p>Here are our pricing details.</p>
    </div>
  );
};

export default Pricing; 
